export const SUCCESS_IMAGE = "https://bucket.sevedemo.com/assets/success.png";
export const ERROR_IMAGE = "https://bucket.sevedemo.com/assets/declined.png";

export const VERIFY_IMAGE = "https://bucket.sevedemo.com/assets/sent-email.png";
